/**
 * Colours and button style of the form step's content in Karo's boards
 * (`--ink`, `--ink-2`, `--ink-3`, `--line`, DS field and link blues).
 */
export const FORM_COLORS = {
  ink: "#1A2340",
  ink2: "#4B5468",
  ink3: "#6B7385",
  line: "#E1E5EE",
  /** Divider inside a field and the field's own border (`--line-2`). */
  line2: "#CBD2E0",
  /** DS field background and its hover. */
  field: "#F0F5FC",
  fieldHover: "#E8EFFC",
  /** Value text of a DS field and the focus line. */
  text: "#001E64",
  /** DS labels, placeholders and links. */
  link: "#1A4CBF",
  navy: "#001E64",
  /** Title of the lookup box (`--navy`). */
  boxTitle: "#1E3A78",
  tintBorder: "#DCE5F6",
  muted: "#6B7385",
} as const;

/**
 * The value text of a DS field: what the number input draws, and the phone
 * field's dial code beside it, so both read as one value.
 */
export const FIELD_VALUE_TEXT_SX = {
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: ".5px",
  color: FORM_COLORS.text,
} as const;

/** The board's `.btn.text.sm`: 32px, 13/22, uppercase, .46px, hover #F0F5FC. */
export const TEXT_BUTTON_SX = {
  minWidth: 0,
  height: 32,
  px: "5px",
  fontSize: 13,
  lineHeight: "22px",
  letterSpacing: ".46px",
  fontWeight: 500,
  textTransform: "uppercase",
  color: FORM_COLORS.navy,
  borderRadius: "4px",
  "&:hover": { bgcolor: FORM_COLORS.field },
} as const;
